import {Anchor, Banner} from '@albert-io/atomic';
import React from 'react';

interface Props {
  link: string;
  className?: string;
}

export const ReportsLinkBanner = ({link, className}: Props) => {
  return (
    <Banner theme='blue' className={className}>
      <Banner.Icon icon='sparkles' iconStyle='regular' />
      <span>
        <Anchor href={link} className='u-text-decoration_underline' inheritColor>
          Click here
        </Anchor>{' '}
        to access a more powerful version of this report!
      </span>
    </Banner>
  );
};
